import { combineReducers } from 'redux';
import courseOutlineConfig from 'legacy/src/utility/CourseOutlineConfig/state/reducer';

import filter from './components/Filters/state/reducer';

const rootReducer = combineReducers({
  filter,
  courseOutlineConfig,
});

export default rootReducer;
